export default function () {
  return {
    primaryPerson: false,
    settings: [],
    searchResults: [],
    proxyPerson: false,
    personGroups: [],
    timeout: false
  }
}
